import { useToastContext } from '../context/ToastContext';

export default function useToast() {
  const { addToast } = useToastContext();

  return {
    success: (msg, options = {}) => addToast(msg, { ...options, type: 'success' }),
    error: (msg, options = {}) => addToast(msg, { ...options, type: 'error' }),
    warning: (msg, options = {}) => addToast(msg, { ...options, type: 'warning' }),
    info: (msg, options = {}) => addToast(msg, { ...options, type: 'info' }),
  };
}
